class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.portalToBody = this.hasAttribute('data-portal-to-body');
    this.modalContent = this.querySelector('.modal__content');
    this.closeButton = this.querySelector('.modal__close-button');
    this.portalPlaceholder = document.createComment('details-modal-portal');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.closeButton?.addEventListener('click', this.onCloseButtonClick.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const isInsideModal = this.contains(event.target) || this.modalContent?.contains(event.target);

    if (!isInsideModal || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  onCloseButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.close();
  }

  onDocumentKeyup(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.close();
  }

  portalModalContent() {
    if (!this.portalToBody || !this.modalContent || this.modalContent.parentElement === document.body) return;

    this.modalContent.parentNode.insertBefore(this.portalPlaceholder, this.modalContent);
    document.body.appendChild(this.modalContent);
  }

  restoreModalContent() {
    if (!this.portalToBody || !this.modalContent || !this.portalPlaceholder.parentNode) return;

    this.portalPlaceholder.parentNode.insertBefore(this.modalContent, this.portalPlaceholder);
    this.portalPlaceholder.remove();
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.onDocumentKeyupEvent = this.onDocumentKeyupEvent || this.onDocumentKeyup.bind(this);
    event.target.closest('details').setAttribute('open', true);
    this.portalModalContent();
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.addEventListener('keyup', this.onDocumentKeyupEvent);
    document.body.classList.add('overflow-hidden');

    const focusContainer =
      this.modalContent?.querySelector('[tabindex="-1"]') || this.detailsContainer.querySelector('[tabindex="-1"]');
    const focusTarget =
      this.modalContent?.querySelector(
        '[role="tab"][aria-selected="true"], input:not([type="hidden"]), button:not(.modal__close-button), a[href], select, textarea, [tabindex]:not([tabindex="-1"])'
      ) ||
      this.detailsContainer.querySelector(
        '[role="tab"][aria-selected="true"], input:not([type="hidden"]), button:not(.modal__close-button), a[href], select, textarea, [tabindex]:not([tabindex="-1"])'
      ) ||
      focusContainer;

    trapFocus(focusContainer, focusTarget);
  }

  close(focusToggle = true) {
    if (focusToggle instanceof Event) focusToggle = true;

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.restoreModalContent();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.removeEventListener('keyup', this.onDocumentKeyupEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
